enum HealthCheckStatusEnum {
  working = 'working',
  unavailable = 'unavailable',
}

export default HealthCheckStatusEnum;
